import { Box, IconButton, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const Pagination = styled(Box)({
	...flexMixin({ gap: 20 }),
});

export const PaginationButton = styled(IconButton)({
	'&.Mui-disabled': {
		opacity: 0.5,
	},

	'& svg': {
		height: '25px',
		width: '25px',
	},
});
